import hichar from "@/config/api/hichar";

export default {
	projectName: '桩交所',
	projectTitle: '桩交所',
	baseUrl: '',
	brand: '桩交所',
	appId: 'hichar.charge.trade.web',//hichar.charge.trade.web
	header: [{
		key: 'appId',
		value: 'hichar.charge.trade.web'
	}],
	tokenKey: 'token',
	timeout: 1000 * 60 * 60, // 1个小时
	defaultTimeout: 1000 * 60 * 5, // 5分钟
	axiosBaseUrl: require('../config/env.' + process.env.NODE_ENV).baseUrl, //
	apiUrl: {
		...hichar,
	},
};
